import React from 'react';
import Helmet from 'react-helmet';

import Navbar from '../components/navbar/navbar';
import MainLayout from '../layouts/layout';
import Button from '../components/button/button';
import Header1 from '../components/typographies/header1';
import Header4 from '../components/typographies/header4';
import Header5 from '../components/typographies/header5';
import Para1 from '../components/typographies/para1';
import Para2 from '../components/typographies/para2';
import ProblemList from '../components/list/problemList';

import Dreamer from '../static/Dreamer.svg';

import Link from 'gatsby-link'
import 'isomorphic-fetch';

export default class Home extends React.Component {
  // event handler
  handlePostProblemClick(e) {
    e.preventDefault();

    window.open('https://surebro.typeform.com/to/VdZ7oP', '_blank');
  }
  // render methods
  render() {
    return (
      <MainLayout key="main-layout">
        <Helmet>
          <title>Surebro: We'll solve your problems</title>
          <meta name="description" content="We solve problems for free. Post your problem and we will build you an application, web or mobile that will hopefully solve your problem. For free. Really free" />
          <meta property="og:url" content="https://surebro.com/problems" />
          <meta property="og:title" content="Surebro: We'll solve your problems" />
          <meta property="og:description" content="We solve problems for free. Post your problem and we will build you an application, web or mobile that will hopefully solve your problem. For free. Really free" />
          <meta property="og:image" content="https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png" />
        </Helmet>
        <Navbar key="navbar" active={2} className="yellow" />
        <section className="container" style={{ marginTop: '160px' }}>
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 col-xs-12">
              <Header1
                  key="header"
                  className="text-center stronger"
                  text="We'll build you an application for Free"
                  decoration={{ text: 'for Free', type: 'underline', color: 'yellow' }}
              />
              <Para1
                  key="sub-title"
                  className="text-center grey light"
                  text="Tell us your problems and we will build a website, application, anything that solves your problem for free"
              />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xs-12 col-sm-6">
              <div className="row justify-content-center">
                <Button
                    key="primary-button"
                    onClick={this.handlePostProblemClick.bind(this)}
                    text="Post your Problem"
                    className="yellow center-block margin-t-20"
                />
              </div>
            </div>
          </div>
        </section>
        <div className="container-fluid margin-t-60 project-strip" style={{
          backgroundImage: `url(https://res.cloudinary.com/surebro/image/upload/q_auto/v3-static/ApplicationStrip_2x.35b42f85)`
        }}></div>
        <section className="container margin-t-100">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 col-xs-12">
              <Header1
                  key="header"
                  className="text-center stronger"
                  text="We are Engineers and Designers"
              />
              <Para1
                  key="sub-title"
                  className="text-center grey light"
                  text="All we want to do is solve real problem faced by real people. Everyone encounters this one problem that is painfully obvious"
              />
              <Para1
                  key="sub-title-2"
                  className="text-center grey strong"
                  text="“Why is there no app that helps with this?”"
              />
              <Para1
                  key="sub-title-3"
                  className="text-center grey light"
                  text="Well, if you tell us, we’ll build it and it’ll be free"
              />
            </div>
          </div>
        </section>
        <section className="container margin-t-100">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="row align-items-center">
                <div className="col-md">
                    <Header4
                        key="step-one-title"
                        className="text-left margin-t-10"
                        text="Your dreams will come true"
                    />
                    <Para2
                        key="step-one-subtitle"
                        className="text-left grey margin-t-10 spread"
                        text="All you need to do is share your dreams. Share your problems, propose a solution, point to a solution\
                        that needs a minor tweak. Anything. We will build it for you. And it will not cost you a penny. You will be\
                        the reason it exists. Imagine the bragging rights."
                    />
                </div>
                <div className="col-md mobile-flex-first">
                  <img src={Dreamer} className="img-fluid rounded mx-auto d-block img-max-h-400" alt="Dream on Dreamer" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="container margin-t-100" onClick={this.handlePostProblemClick.bind(this)}>
          <button className="yellow super button padding-50 ">
            <div className="row">
              <Para1
                  key="richard-intro"
                  className="text-left white"
                  text="In the words of the mighty Richard Branson, "
              />
            </div>
            <div className="row">
              <Header1
                  key="richard-title"
                  className="stronger text-left underline white"
                  text="Screw it, Let’s do it"
              />
            </div>
          </button>
        </section>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/problems.js